import http from './http'

export function verify(otp, username, mode) {
  return http.post("/v1/profile/authentication/otp/token", {otp, username, mode})
}

export function reset_code(username) {
  return http.delete("/v1/profile/authentication/otp/code",{ data: { username }})
}
